"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const apiClient = axios_1.default.create({
    baseURL: "/",
    headers: {
        "Content-type": "application/json",
    },
    timeout: 15000,
    validateStatus: function (status) {
        return (status >= 200 && status < 300) || status === 400 || status === 409;
    }
});
exports.default = apiClient;
